<template>
  <div>
    <label><b>{{ name }}</b></label>
    <div class="slider-container sku-slider">
      <div class="chrome">
        <input
          type="range"
          :min="1"
          :max="filteredOptions.length"
          step="1"
          v-model="rangeValue"
          @change="updateSliderValues"
          @mouseleave="updateSliderValues"
          id="rangeSlider"
        />
      </div>
      <div class="slider-values">
        <span v-for="(value, index) in filteredOptions" :key="index">{{ value.option_name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      required: false,
    },
    slug: {
      type: String,
      required: true,
    },
    selectedValue: {
      type: Number,
      required: false,
    }
  },
  data() {
    return {
      rangeValue: 1,
      sliderValues: [],
      lastEmittedValue: null,
    };
  },
  methods: {
    updateSliderValues() {
      // Get the new range value
      const newRangeValue = parseInt(this.rangeValue);

      // Update slider values only if the new range value is different from the last emitted value
      if (newRangeValue !== this.lastEmittedValue) {
        this.sliderValues = this.filteredOptions.slice(0, newRangeValue).map(option => option.option_value);

        // Emit the selected option value and slug
        const selectedOption = this.filteredOptions[newRangeValue - 1]; // -1 because rangeValue starts from 1
        this.$emit('option-selected', {
          value: selectedOption.option_value,
          slug: this.slug,
          image: selectedOption.option_img,
          gallery: selectedOption.option_gallery
        });
        
        // Update the last emitted value
        this.lastEmittedValue = newRangeValue;
      }
    },
    setInitialRangeValue() {
      // Find the index of the selected value in the filtered options
      const selectedIndex = this.filteredOptions.findIndex(option => option.option_id === this.selectedValue);

      if (selectedIndex !== -1) {
        // Set range value based on the index (+1 because range starts from 1)
        this.rangeValue = selectedIndex + 1;
      } else {
        // Default to the first option if selectedValue is not found
        this.rangeValue = 1;
      }
      // Update slider values after setting rangeValue
      this.updateSliderValues();
    }
  },
  computed: {
    filteredOptions() {
      const activeOptions = this.options.filter(option => option.option_active);
      return activeOptions;
    }
  },
  watch: {
    options: {
      handler() {
        // Reset the slider values when options prop changes
        this.updateSliderValues();
      },
      immediate: true,
      deep: true
    },
    selectedValue: {
      handler() {
        // Update the slider when selectedValue prop changes
        this.setInitialRangeValue();
      },
      immediate: true
    }
  },
  mounted() {
    // Initialize slider values on mount
    this.setInitialRangeValue();
  }
};
</script>

